import { api } from "./client";

export type Comment = {
  comment_id: number;
  post_id: number;
  author_id: number;
  username: string;
  content: string;
  created_at: string;
  vote_score: number;
  post_title?: string;
};

export async function getComments(postId: number) {
  return api<Comment[]>(`/posts/${postId}/comments`, "GET");
}

export async function createComment(post_id: number, content: string) {
  return api(`/comments`, "POST", { post_id, content }, true);
}

export async function deleteComment(id: number) {
  return api(`/comments/${id}`, "DELETE", undefined, true);
}
